import { lazy } from 'react'

const Management = lazy(async () => {
  const { Management: ManagementModule } = await import(
    /* webpackChunkName: "management" */ './'
  )

  return {
    default: ManagementModule
  }
})
const routes = [
  {
    path: '/management',
    name: 'Management',
    authenticated: true,
    render(props) {
      return <Management {...props} />
    }
  }
]

export { routes }
